module.exports = "/packs/sns-icon-ig-26b7b4f4c1d392c7723b5f4e4ffd9688.png";